import React from 'react';
import './DrQuackMascot.css';

/**
 * Dr. Quack mascot — the friendly duck shown in the AI intro and the
 * floating chat widget.
 *
 * Drop the PNG asset at `src/assets/dr-quack.png` (the same file the
 * mobile app uses at `mobile/assets/dr-quack.png`). Both clients render
 * the same character so users see a consistent personality.
 *
 * Props:
 *   - size: pixel dimension of the rendered image (default 120)
 *   - animate: when true, applies a soft breathing loop. Use this in the
 *     intro screen and the floating bubble; turn it off (false) for tiny
 *     inline avatars in chat bubbles where the motion would be noisy.
 */
export default function DrQuackMascot({ size = 120, animate = true }) {
  return (
    <div
      className={`dr-quack-mascot ${animate ? 'is-animating' : ''}`}
      style={{ width: size, height: size }}
    >
      <img
        src={require('../assets/dr-quack.png')}
        alt="Dr. Quack"
        className="dr-quack-mascot-img"
        draggable={false}
      />
    </div>
  );
}

/**
 * Three little dots that bounce — used as a "duck is typing" indicator in
 * chat bubbles. Standalone so we can drop it anywhere without pulling in
 * the mascot image.
 */
export function DuckTypingDots({ color = '#5CB89A', size = 7 }) {
  return (
    <div className="dr-quack-typing-dots">
      {[0, 1, 2].map((i) => (
        <span
          key={i}
          className="dr-quack-typing-dot"
          style={{
            backgroundColor: color,
            width: size,
            height: size,
            animationDelay: `${i * 140}ms`,
          }}
        />
      ))}
    </div>
  );
}